import React from 'react';
import { contextFactory } from '@10d/tend-ui-factories';
import { SamoletTheme } from './SamoletTheme.js';
import { GlobalTheme } from './GlobalTheme.js';

const [ThemeContext, useTheme] = contextFactory('ThemeContext', SamoletTheme);
const useColors = () => {
    return useTheme().colors;
};
const useColor = (color, defaultColor) => {
    const colors = useColors();
    const presets = Object.keys(colors);
    if (!color)
        return defaultColor;
    const k = color;
    return presets.includes(color) ? colors[k] : color;
};
const themes = {
    samolet: SamoletTheme,
    global: GlobalTheme,
};
const Theme = ({ children, theme, }) => {
    return React.createElement(ThemeContext, { value: themes[theme] }, children);
};

export { Theme, useColor, useColors, useTheme };
//# sourceMappingURL=Theme.js.map
